import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { QuantityFormatResponseModel } from '~/models/administration/quantityFormat';
import { ApiServiceBase, API_NAMES } from '../api';

@Injectable({ providedIn: 'root' })
export class QuantityFormatsService extends ApiServiceBase {
     quantityFormat:string;
    constructor(injector: Injector, private http: HttpClient) {

        super(injector);
        this.setBase(API_NAMES.settings);
        if(localStorage.getItem('accessToken') || localStorage.getItem('refreshToken'))
        this.getQuantityFormatForNumericTextBox();
    }

    updateQuantityFormatsSetting(model: any) {
        return this.client.put(this._url(), model);
    }


    getQuantityFormatSetting(){
        return this.http.get<QuantityFormatResponseModel>(this._url());
  }
  getPipeQuantityFormatSetting(){
    return this.http.get<QuantityFormatResponseModel>(this._url())
    .subscribe((data: any) => {

        if(data.digitNumber==0)
        this.quantityFormat='1.0-0'
        else if(data.digitNumber==1)
        this.quantityFormat='1.1-1'
        else if(data.digitNumber==2)
        this. quantityFormat='1.2-2'
        else if(data.digitNumber==3)
        this.quantityFormat='1.3-3'
        else if(data.digitNumber==4)
        this.quantityFormat='1.4-4'
});
}
    async getQuantityFormatForNumericTextBox(){
        var format : string = 'n';
        await this.http.get<QuantityFormatResponseModel>(this._url())
        .pipe()
            .toPromise()
            .then((data) => {
                if(!data || data.digitNumber == null){
                    format = format + '0';
                }
                else{
                    format = format + data.digitNumber;
                }
            });

        return format;
    }


    async getDigitNumber(format : string){
        var splitedFormat : string[] = format.split('n');
        var digitNumber : number = +splitedFormat[1];

        return digitNumber;
    }

    private _url(v?: string | undefined) {
        v = v || '';
        return this.url(`/QuantityFormats${v}`);
    }
}
